import React from 'react';
import {
    Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip
} from 'recharts';
import { radarAxes } from '../../data/developmentLaws';

const AbilityRadarChart = ({ data, dataKey = "score", color = "#6366f1" }) => {
    // data should be an object like: { integrationThinking: 80, adaptiveDevelopment: 65, ... }
    // We need to transform it to array format for Recharts

    const chartData = radarAxes.map(axis => ({
        subject: axis.name,
        score: data?.[axis.key] || 0, // specific member score
        fullMark: 100,
        axisKey: axis.key
    }));

    return (
        <div className="w-full h-[300px] sm:h-[400px]">
            <ResponsiveContainer width="100%" height="100%">
                <RadarChart cx="50%" cy="50%" outerRadius="70%" data={chartData}>
                    <PolarGrid stroke="#e5e7eb" />
                    <PolarAngleAxis
                        dataKey="subject"
                        tick={{ fill: '#4b5563', fontSize: 12 }}
                    />
                    <PolarRadiusAxis
                        angle={30}
                        domain={[0, 100]}
                        tick={false}
                        axisLine={false}
                    />
                    <Radar
                        name="Score"
                        dataKey="score"
                        stroke={color}
                        strokeWidth={3}
                        fill={color}
                        fillOpacity={0.3}
                    />
                    <Tooltip
                        contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
                        itemStyle={{ color: color, fontWeight: 'bold' }}
                    />
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default AbilityRadarChart;
